import { objectToDict } from '@bd/vue3-utils'
export enum GENDER {
  /** 男 */
  MALE = 1,
  /** 女 */
  FEMALE = 0
}
export const GENDER_LABEL = {
  [GENDER.MALE]: '男',
  [GENDER.FEMALE]: '女'
}
export const GENDER_OPTIONS = objectToDict(GENDER_LABEL, true)
/** 项目类型 */
export enum PROJ_TYPE {
  /** 集体土地 */
  JT = 0,
  /** 国有土地 */
  GY = 1
}
export const PROJ_TYPE_LABEL = {
  [PROJ_TYPE.JT]: '集体土地项目',
  [PROJ_TYPE.GY]: '国有土地项目'
}
export const PROJ_TYPE_OPTIONS = objectToDict(PROJ_TYPE_LABEL, true)

/** 集体土地项目类型 */
export enum JT_PROJ_TYPE {
  CITY = 0,
  TOWN = 1
}
export const JT_PROJ_TYPE_LABEL = {
  [JT_PROJ_TYPE.CITY]: '城区拆迁',
  [JT_PROJ_TYPE.TOWN]: '乡镇拆迁'
}
export const JT_PROJ_TYPE_OPTIONS = objectToDict(JT_PROJ_TYPE_LABEL, true)

/** 集体土地项目进度 */
export const JT_PROJ_PROGRESS = [
  { label: '启动', value: 'qiDong' },
  { label: '动员大会', value: 'dongYuanDaHui' },
  { label: '集体土地征收（村组协议）', value: 'jiTiTuDiZhengShou' },
  { label: '资金监审', value: 'ziJinJianShen' },
  { label: '资金结算', value: 'ziJinJieSuan' },
  { label: '征拆户录入', value: 'zhengChaiHuLuRu' },
  { label: '征拆户协议签订', value: 'zhengChaiHuXieYiQianDing' },
  { label: '保险购买', value: 'baoXianGouMai' },
  { label: '结项', value: 'jieXiang' }
]

/** 国有土地项目进度 */
export const GY_PROJ_PROGRESS = [
  { label: '启动', value: 'qiDong' },
  { label: '摸底建档', value: 'moDiJianDang' },
  { label: '动员大会', value: 'dongYuanDaHui' },
  { label: '选定评估公司', value: 'xuanDingPingGuGongSi' },
  { label: '入户评估', value: 'ruHuPingGu' },
  { label: '预评估公示', value: 'yuPingGuGongShi' },
  { label: '征拆户录入', value: 'zhengChaiHuLuRu' },
  { label: '资金请批', value: 'ziJinQingPi' },
  { label: '房屋拆除', value: 'fangWuChaiChu' },
  { label: '搬离、放款', value: 'banLiFangKuan' },
  { label: '产证注销', value: 'chanZhengXiaoZhu' },
  { label: '结项', value: 'jieXiang' }
]
/** 项目步骤进度状态 */
export enum PROJ_PROGRESS_STATUS {
  /** 未开始 */
  NOT_STARTED = 0,
  /** 进行中 */
  IN_PROGRESS = 1,
  /** 已完成 */
  COMPLETED = 2
}
export const PROJ_PROGRESS_STATUS_LABEL = {
  [PROJ_PROGRESS_STATUS.NOT_STARTED]: '未开始',
  [PROJ_PROGRESS_STATUS.IN_PROGRESS]: '进行中',
  [PROJ_PROGRESS_STATUS.COMPLETED]: '已完成'
}
export const PROJ_PROGRESS_STATUS_COLOR = {
  [PROJ_PROGRESS_STATUS.NOT_STARTED]: 'warning',
  [PROJ_PROGRESS_STATUS.IN_PROGRESS]: 'processing',
  [PROJ_PROGRESS_STATUS.COMPLETED]: 'success'
}
export const PROJ_PROGRESS_STATUS_OPTIONS = objectToDict(PROJ_PROGRESS_STATUS_LABEL, true)

/** 集体土地项目信息录入模块 */
export enum JT_PROJ_MODULE {
  /** 基本信息 */
  BASIC_INFO = '0',
  /** 项目进度 */
  PROGRESS = '1',
  /** 拆迁点位 */
  POINT = '2',
  /** 拆迁补偿标准 */
  COMP_STANDARD = '3',
  /** 人员安置标准 */
  RESETTLE_STANDARD = '4',
  /** 结项 */
  CLOSURE = '5',
  /** 征拆户列表 */
  ZCH_LIST = '6',
  /** 资金监审 */
  FUND_AUDIT = '7',
  /** 动员大会 */
  KICKOFF_MEETING = '8',
  /** 原始档案信息 */
  ORIGIN_ARCHIVE = '9',
  /** 村组协议 */
  GROUP_AGREEMENT = '10',
  /** 资金结算 */
  FUND_CLEARING = '11',
  /** 征拆补偿资金汇总（不包括安置） */
  FUND_SUMMARY = '12',
  /** 被征地农民养老保险 */
  PENSION_INSURANCE = '13',
  /** 安置监审 */
  RESETTLE_AUDIT = '14',
  /** 社保导入 */
  SS_IMPORT = '15',
  /** 征拆前照片 */
  PRE_PHOTO = '16'
}

/** 集体土地项目-被征地农民养老保险-审核状态 */
export enum PENSION_INSURANCE_REVIEW_STATUS {
  /** 参保名额测算-待审核 */
  CBMECS_PENDING = -1,
  /** 参保名额测算-驳回 */
  CBMECS_REJECT = 0,
  /** 参保名额测算-同意 */
  CBMECS_RESOLVE = 1,
  /** 人员名单复核-待审核 */
  RYMDFH_PENDING = -2,
  /** 人员名单复核-驳回 */
  RYMDFH_REJECT = 2,
  /** 人员名单复核-同意 */
  RYMDFH_RESOLVE = 3
}
export const PENSION_INSURANCE_REVIEW_STATUS_LABEL = {
  [PENSION_INSURANCE_REVIEW_STATUS.CBMECS_PENDING]: '参保名额测算-待审核',
  [PENSION_INSURANCE_REVIEW_STATUS.CBMECS_REJECT]: '参保名额测算-驳回',
  [PENSION_INSURANCE_REVIEW_STATUS.CBMECS_RESOLVE]: '参保名额测算-同意',
  [PENSION_INSURANCE_REVIEW_STATUS.RYMDFH_PENDING]: '人员名单复核-待审核',
  [PENSION_INSURANCE_REVIEW_STATUS.RYMDFH_REJECT]: '人员名单复核-驳回',
  [PENSION_INSURANCE_REVIEW_STATUS.RYMDFH_RESOLVE]: '人员名单复核-同意'
}
export const PENSION_INSURANCE_REVIEW_STATUS_COLOR = {
  [PENSION_INSURANCE_REVIEW_STATUS.CBMECS_PENDING]: 'warning',
  [PENSION_INSURANCE_REVIEW_STATUS.CBMECS_REJECT]: 'error',
  [PENSION_INSURANCE_REVIEW_STATUS.CBMECS_RESOLVE]: 'success',
  [PENSION_INSURANCE_REVIEW_STATUS.RYMDFH_PENDING]: 'warning',
  [PENSION_INSURANCE_REVIEW_STATUS.RYMDFH_REJECT]: 'error',
  [PENSION_INSURANCE_REVIEW_STATUS.RYMDFH_RESOLVE]: 'success'
}
/** 集体土地征拆户信息录入模块 */
export enum JT_ZCH_MODULE {
  /** 基本信息 */
  BASIC_INFO = '0',
  /** 购房合同 */
  GOU_FANG_CONTRACT = '1',
  /** 人员信息 */
  FAMILY_MEMBERS = '2',
  /** 社保情况 */
  SOCIAL_SECURITY = '3',
  /** 相关照片 */
  RELATED_PHOTOS = '4',
  /** 拆迁补偿安置协议 */
  COMP_AGREEMENT = '5',
  /** 附件 */
  ATTACHMENTS = '6',
  /** 人员安置 */
  RESETTLE = '7',
  /** 拆迁补偿 */
  COMP = '8',
  /** 原始档案信息 */
  ORIGIN_ARCHIVE = '9'
}

/** 集体土地征拆户-人员-与户主关系-本人-字典值 */
export const OWNER_RELATIONSHIP_SELF_DICT_VALUE = 'fgvk30+OwSdia3vEWWMHjg=='
/** 集体土地征拆户-人员-安置方式 */
export enum RESETTLE_WAY {
  /** 货币化安置 */
  CASH = 'isCurrency',
  /** 房票安置 */
  TICKET = 'isTicket',
  /** 统规自建安置 */
  PERSON_PLAN = 'isPersonPlan',
  /** 统规统建安置 */
  COMMON_PLAN = 'isCommonPlan'
}

/** 集体土地征拆户-人员-安置方式-标签 */
export const RESETTLE_WAY_LABEL = {
  [RESETTLE_WAY.CASH]: '货币化安置',
  [RESETTLE_WAY.TICKET]: '房票安置',
  [RESETTLE_WAY.PERSON_PLAN]: '统规自建安置',
  [RESETTLE_WAY.COMMON_PLAN]: '统规统建安置'
}
/** 集体土地征拆户-人员-安置方式-颜色 */
export const RESETTLE_WAY_COLOR = {
  [RESETTLE_WAY.CASH]: 'blue',
  [RESETTLE_WAY.TICKET]: 'green',
  [RESETTLE_WAY.PERSON_PLAN]: 'orange',
  [RESETTLE_WAY.COMMON_PLAN]: 'purple'
}
/** 集体土地征拆户-协议-类型 */
export enum JT_ZCH_AGREEMENT_TYPE {
  TOWN_COMPENSATION_TICKET = 'townCompensationTicket',
  TOWN_COMPENSATION = 'townCompensation',
  CITY_COMPENSATION = 'cityCompensation',
  TICKET_NOTICE = 'ticketNotice',
  TICKET_CONFIRMATION = 'ticketConfirmation',
  GIVE_UP_RESIDUAL_VALUE = 'giveUpResidualValue',
  // 乡镇-房票安置补充协议
  TOWN_TICKET_SUPPLEMENT = 'townTicketSupplement',
  // 城区-拆迁安置补充协议
  CITY_TICKET_SUPPLEMENT = 'cityTicketSupplement',
  // 乡镇-搬迁安置补偿协议
  TOWN_RELOCATION_COMPENSATION = 'townRelocationCompensation',
  // 城区-搬迁安置补偿协议
  CITY_RELOCATION_COMPENSATION = 'cityRelocationCompensation',
  // 乡镇-房票搬迁安置补偿协议
  TOWN_TICKET_RELOCATION_COMPENSATION = 'townTicketRelocationCompensation',
  // 乡镇搬迁-房票安置补充协议
  CITY_TICKET_RELOCATION_SUPPLEMENT = 'cityTicketRelocationSupplement'
}
/** 集体土地征拆户-协议-类型标签 */
export const JT_ZCH_AGREEMENT_TYPE_LABEL = {
  [JT_ZCH_AGREEMENT_TYPE.TOWN_COMPENSATION_TICKET]: '乡镇拆迁-房票拆迁安置补偿协议',
  [JT_ZCH_AGREEMENT_TYPE.TOWN_COMPENSATION]: '乡镇拆迁-拆迁安置补偿协议',
  [JT_ZCH_AGREEMENT_TYPE.CITY_COMPENSATION]: '城区拆迁-拆迁安置补偿协议',
  [JT_ZCH_AGREEMENT_TYPE.TICKET_NOTICE]: '房票安置通知书',
  [JT_ZCH_AGREEMENT_TYPE.TICKET_CONFIRMATION]: '房票安置价款确认书',
  [JT_ZCH_AGREEMENT_TYPE.GIVE_UP_RESIDUAL_VALUE]: '放弃残值承诺书',
  [JT_ZCH_AGREEMENT_TYPE.TOWN_TICKET_SUPPLEMENT]: '乡镇拆迁-房票安置补充协议',
  [JT_ZCH_AGREEMENT_TYPE.CITY_TICKET_SUPPLEMENT]: '城区拆迁-房票安置补充协议',
  [JT_ZCH_AGREEMENT_TYPE.TOWN_RELOCATION_COMPENSATION]: '乡镇搬迁-搬迁安置补偿协议',
  [JT_ZCH_AGREEMENT_TYPE.CITY_RELOCATION_COMPENSATION]: '城区搬迁-搬迁安置补偿协议',
  [JT_ZCH_AGREEMENT_TYPE.TOWN_TICKET_RELOCATION_COMPENSATION]: '乡镇搬迁-房票搬迁安置补偿协议',
  [JT_ZCH_AGREEMENT_TYPE.CITY_TICKET_RELOCATION_SUPPLEMENT]: '乡镇搬迁-房票安置补充协议'
}
/** 集体土地征拆户-人员-货币化安置方式 */
export enum JT_ZCH_CURRENCY_TYPE {
  /** 县城规划区 */
  CITY = 0,
  /** 乡镇 */
  TOWN = 1
}
/** 集体土地征拆户-人员-货币化安置方式标签 */
export const JT_ZCH_CURRENCY_TYPE_LABEL = {
  [JT_ZCH_CURRENCY_TYPE.CITY]: '县城规划区',
  [JT_ZCH_CURRENCY_TYPE.TOWN]: '乡镇'
}
/** 集体土地征拆户-人员-货币化安置方式选项 */
export const JT_ZCH_CURRENCY_TYPE_OPTIONS = objectToDict(JT_ZCH_CURRENCY_TYPE_LABEL, true)
/** 集体土地征拆户-协议-类型选项 */
export const JT_ZCH_AGREEMENT_TYPE_OPTIONS = objectToDict(JT_ZCH_AGREEMENT_TYPE_LABEL)
/** 征拆户-审核状态 */
export enum ZCH_REVIEW_STATUS {
  /** 待审核 */
  PENDING = -1,
  /** 初审驳回 */
  FIRST_REJECT = 0,
  /** 初审通过 */
  FIRST_APPROVE = 1,
  /** 待终审 */
  FINAL_PENDING = -2,
  /** 终审驳回 */
  FINAL_REJECT = 2,
  /** 终审通过 */
  FINAL_APPROVE = 3
}
/** 征拆户-审核状态标签 */
export const ZCH_REVIEW_STATUS_LABEL = {
  [ZCH_REVIEW_STATUS.PENDING]: '待审核',
  [ZCH_REVIEW_STATUS.FIRST_REJECT]: '初审驳回',
  [ZCH_REVIEW_STATUS.FIRST_APPROVE]: '初审通过',
  [ZCH_REVIEW_STATUS.FINAL_PENDING]: '待终审',
  [ZCH_REVIEW_STATUS.FINAL_REJECT]: '终审驳回',
  [ZCH_REVIEW_STATUS.FINAL_APPROVE]: '终审通过'
}
/** 征拆户-审核状态选项 */
export const ZCH_REVIEW_STATUS_OPTIONS = objectToDict(ZCH_REVIEW_STATUS_LABEL, true)
/** 征拆户-审核状态颜色 */
export const ZCH_REVIEW_STATUS_COLOR = {
  [ZCH_REVIEW_STATUS.PENDING]: 'warning',
  [ZCH_REVIEW_STATUS.FIRST_REJECT]: 'error',
  [ZCH_REVIEW_STATUS.FIRST_APPROVE]: 'success',
  [ZCH_REVIEW_STATUS.FINAL_PENDING]: 'warning',
  [ZCH_REVIEW_STATUS.FINAL_REJECT]: 'error',
  [ZCH_REVIEW_STATUS.FINAL_APPROVE]: 'success'
}

/** 国有土地项目信息录入模块 */
export enum GY_PROJ_MODULE {
  /** 基本信息 */
  BASIC_INFO = '0',
  /** 项目进度 */
  PROGRESS = '1',
  /** 改造点位 */
  POINT = '2',
  /** 摸底建档 */
  SURVEY_ARCHIVE = '3',
  /** 动员大会 */
  KICKOFF_MEETING = '4',
  /** 选定评估公司 */
  APPRAISAL_COMPANY = '5',
  /** 入户评估 */
  HOME_ASSESSMENT = '6',
  /** 预评估公示 */
  PRE_ASSESSMENT_NOTICE = '7',
  /** 资金请批 */
  FUND_APPROVAL = '8',
  /** 房屋拆除 */
  HOUSE_DEMOLITION = '9',
  /** 产证注销 */
  CERT_CANCEL = '10',
  /** 原始档案信息 */
  ORIGIN_ARCHIVE = '11',
  /** 结项 */
  CLOSURE = '12',
  /** 征拆户列表 */
  ZCH_LIST = '13'
}

/** 国有土地项目-征拆户-录入模块 */
export enum GY_ZCH_MODULE {
  /** 基本信息 */
  BASIC_INFO = '0',
  /** 房屋信息 */
  HOUSE_INFO = '1',
  /** 产权人信息 */
  OWNER_INFO = '2',
  /** 其他信息 */
  OTHER_INFO = '3',
  /** 原始档案信息 */
  ORIGIN_ARCHIVE = '4',
  /** 附件 */
  ATTACHMENTS = '5'
}

/** 房屋类型-门市-字典key */
export const HOUSE_TYPE_SHOP_DICT_KEY = 'EBZ3p1cRr/jH0kw7ytzDzQ=='
/**  房屋类型-住宅-字典key */
export const HOUSE_TYPE_RESIDENTIAL_DICT_KEY = 'EvsjkV7cNWQc66IgIPEMbw=='
/** 房屋类型-其他-字典key */
export const HOUSE_TYPE_OTHER_DICT_KEY = 'i0QaeGYwuExgRXBbw669Qg=='
/**
 * 未分配字典key
 */
export const WFP_KEY = 'xAvO+ypFrmFg4atyvZkx2Q=='
/**
 * 已分配未安置字典key
 */
export const YFPWAZ_KEY = 'hlItcz/M8Kjl5q3mpO2Vdg=='
/**
 * 已安置字典key
 */
export const YAZ_KEY = 'Wdtf6hXoKaKt8oRcMHGmtw=='

/** 公式类型 */
export enum FORMULA_TYPE {
  /** 数值计算 */
  MATH = 'math',
  /** 正则提取 */
  REGEX = 'regex',
  /** 文本替换 */
  REPLACE = 'replace'
}

export const FORMULA_TYPE_LABEL = {
  [FORMULA_TYPE.MATH]: '数值计算',
  [FORMULA_TYPE.REGEX]: '正则提取',
  [FORMULA_TYPE.REPLACE]: '文本替换'
}
export const FORMULA_TYPE_OPTIONS = objectToDict(FORMULA_TYPE_LABEL)

/** 房票模式类型 */
export enum TICKET_MODE {
  /** 分期付款(4:2:2) */
  FEN_QI = 0,
  /** 按揭贷（月度） */
  AN_JIE = 1,
  /** 按揭贷（季度） */
  AN_JIE_QUARTER = 2
  /** 安置贷 */
  // SETTLEMENT = 2
}
export const TICKET_MODE_LABEL = {
  [TICKET_MODE.FEN_QI]: '分期付款(4:2:2)',
  [TICKET_MODE.AN_JIE]: '按揭贷（月度）',
  [TICKET_MODE.AN_JIE_QUARTER]: '按揭贷（季度）'
  // [TICKET_MODE.SETTLEMENT]: '安置贷'
}
export const TICKET_MODE_COLOR = {
  [TICKET_MODE.FEN_QI]: 'green',
  [TICKET_MODE.AN_JIE]: 'blue',
  [TICKET_MODE.AN_JIE_QUARTER]: 'purple'
  // [TICKET_MODE.SETTLEMENT]: 'orange'
}
export const TICKET_MODE_OPTIONS = objectToDict(TICKET_MODE_LABEL, true)

/** 小区名称匹配状态 */
export enum COMMUNITY_MATCH_STATUS {
  /** 未匹配 */
  UNMATCHED = -1,
  /** 精准匹配 */
  PRECISE = 0,
  /** 模糊匹配 */
  FUZZY = 1
}
export const COMMUNITY_MATCH_STATUS_LABEL = {
  [COMMUNITY_MATCH_STATUS.UNMATCHED]: '未匹配',
  [COMMUNITY_MATCH_STATUS.PRECISE]: '精准匹配',
  [COMMUNITY_MATCH_STATUS.FUZZY]: '模糊匹配'
}
export const COMMUNITY_MATCH_STATUS_COLOR = {
  [COMMUNITY_MATCH_STATUS.UNMATCHED]: 'default',
  [COMMUNITY_MATCH_STATUS.PRECISE]: 'success',
  [COMMUNITY_MATCH_STATUS.FUZZY]: 'processing'
}
export const COMMUNITY_MATCH_STATUS_OPTIONS = objectToDict(COMMUNITY_MATCH_STATUS_LABEL, true)

/** 小区处理方式 */
export enum COMMUNITY_HANDLE_TYPE {
  /** 不处理 */
  NONE = 0,
  /** 关联小区 */
  ASSOCIATE = 1,
  /** 新建小区 */
  CREATE_NEW = 2
}

/** 房票数据异常类型 */
export enum TICKET_ERR_TYPE {
  REPAY_RATIO_ABNORMAL = 1,
  DATA_MISSING = 2,
  DUPLICATE_DATA = 3,
  IDENTITY_CARD_ABNORMAL = 4,
  DATE_ABNORMAL = 5,
  UNKNOWN_ABNORMAL = 6
}
export const TICKET_ERR_TYPE_LABEL = {
  [TICKET_ERR_TYPE.REPAY_RATIO_ABNORMAL]: '还款比例异常',
  [TICKET_ERR_TYPE.DATA_MISSING]: '数据缺失',
  [TICKET_ERR_TYPE.DUPLICATE_DATA]: '重复数据',
  [TICKET_ERR_TYPE.IDENTITY_CARD_ABNORMAL]: '身份证异常',
  [TICKET_ERR_TYPE.DATE_ABNORMAL]: '日期异常',
  [TICKET_ERR_TYPE.UNKNOWN_ABNORMAL]: '未知异常'
}
export const TICKET_ERR_TYPE_COLOR = {
  [TICKET_ERR_TYPE.REPAY_RATIO_ABNORMAL]: 'error',
  [TICKET_ERR_TYPE.DATA_MISSING]: 'orange',
  [TICKET_ERR_TYPE.DUPLICATE_DATA]: 'purple',
  [TICKET_ERR_TYPE.IDENTITY_CARD_ABNORMAL]: 'volcano',
  [TICKET_ERR_TYPE.DATE_ABNORMAL]: 'magenta',
  [TICKET_ERR_TYPE.UNKNOWN_ABNORMAL]: 'default'
}
export const TICKET_ERR_TYPE_OPTIONS = objectToDict(TICKET_ERR_TYPE_LABEL, true)

/** 房票还款比例上限 */
export const TICKET_REPAY_RATIO_UPPER = 1.16
/** 房票还款比例下限 */
export const TICKET_REPAY_RATIO_LOWER = 0.96

/** 全局搜索来源 */
export enum GLOBAL_SEARCH_SOURCE {
  JT_PROJ = 'cproject',
  GY_PROJ = 'sproject',
  JT_ZCH = 'chousehold',
  GY_ZCH = 'shousehold',
  JT_ZCH_MEMBER = 'cmember',
  GY_ZCH_MEMBER = 'smember',
  POLICY = 'policy',
  NEWS = 'news'
}

export const GLOBAL_SEARCH_SOURCE_LABEL = {
  [GLOBAL_SEARCH_SOURCE.JT_PROJ]: '集体土地项目',
  [GLOBAL_SEARCH_SOURCE.GY_PROJ]: '国有土地项目',
  [GLOBAL_SEARCH_SOURCE.JT_ZCH]: '集体土地征拆户',
  [GLOBAL_SEARCH_SOURCE.GY_ZCH]: '国有土地征拆户',
  [GLOBAL_SEARCH_SOURCE.JT_ZCH_MEMBER]: '集体土地征拆户人员信息',
  [GLOBAL_SEARCH_SOURCE.GY_ZCH_MEMBER]: '国有土地征拆户产权人信息',
  [GLOBAL_SEARCH_SOURCE.POLICY]: '政策法规',
  [GLOBAL_SEARCH_SOURCE.NEWS]: '新闻公告'
}
/** 操作审核数据类型 */
export enum REVIEW_SOURCE_TYPE {
  RESETTLE_AUDIT = 0,
  FUND_AUDIT = 1,
  PENSION_INSURANCE = 2,
  JT_ZCH = 3,
  GY_ZCH = 4
}
